import { QueryResult } from "@/api/utils/types"
import { getOpenComplaints } from "./getOpenComplaints"
import { QueryAggregator } from "@/api/utils/QueryAggregator"
import { IAccountCredit } from "@/models/accountCredit/accountCredit.type"
import { AccountCreditService } from "@/services/AccountCreditService"
import { AccountService } from "@/services/AccountService"

export const getAccountCreditEligibility = (accountNumber: string) => {
  const queries = new QueryAggregator()

  const openComplaintsQuery = getOpenComplaints(accountNumber)
  const coreIdQuery = AccountService.getCoreIdByAccountNumber(accountNumber)

  queries.add(coreIdQuery)
  queries.add(openComplaintsQuery)

  const coreId = coreIdQuery.data
  let hasCreditRelatedToAllOpenComplaints = false
  let accountCreditRecordsQuery: QueryResult<IAccountCredit[]> | null = null

  if (coreId) {
    accountCreditRecordsQuery = AccountCreditService.getCreditByCoreId(coreId)
    queries.add(accountCreditRecordsQuery)

    const goodwillReferenceCode = "Goodwill."
    hasCreditRelatedToAllOpenComplaints = openComplaintsQuery.data.every(
      (complaint) => {
        return accountCreditRecordsQuery?.data.find((credit) => {
          return (
            credit.reason === goodwillReferenceCode &&
            credit.transactionReference === complaint.id.toString()
          )
        })
      },
    )
  }

  const accountCreditEligibility = {
    hasOpenComplaints: openComplaintsQuery.data.length > 0,
    hasCreditRelatedToAllOpenComplaints: hasCreditRelatedToAllOpenComplaints,
    accountCreditRecordsQuery: accountCreditRecordsQuery,
  }

  return queries.setData(accountCreditEligibility).getAggregate()
}
